<template>
  <div>
    <!--timeRemaining: {{ timeRemaining}}
    timertimer_statusActive: {{ timer_status }}
    timer_started_at: {{ timer_started_at }}
    timer_duration: {{ timer_duration }}
    time_remaining: {{ this.$filters.hoursMinutesSeconds(time_remaining) }}-->
    <div style="display: flex; align-items: center">
      <font-awesome-icon
        v-if="timer_status === 'stopped' || timer_status === 'paused'"
        size="lg"
        style="margin-right: 0.3em; cursor: pointer"
        :icon="['far', 'play-circle']"
        v-tooltip="{ content: 'Start Timer'}"
        @click="onStartTimer()"/>
      <!--<font-awesome-icon
        v-if="timer_status === 'running'"
        size="lg"
        style="margin-right: 0.3em; cursor: pointer"
        :icon="['far', 'pause-circle']"
        v-tooltip="{ content: 'Pause Timer'}"
        @click="onPauseTimer()" />-->
      <font-awesome-icon
        v-if="timer_status === 'running' || timer_status === 'paused'"
        size="lg"
        style="margin-right: 0.3em; cursor: pointer"
        :icon="['far', 'stop-circle']"
        v-tooltip="{ content: 'Stop Timer'}"
        @click="onStopTimer()" />

      {{ this.$filters.hoursMinutesSeconds(time_remaining) }}
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import nudge from "@/assets/sounds/nudge.mp3";
import clonedeep from 'lodash.clonedeep'

export default {
  props: {
    timeRemaining: {
      type: Number,
      default: 0
    },
    taskId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      timer_status: 'stopped',
      timer_started_at: 0,
      timer_duration: 0,
    }
  },
  created() {
    this.time_out_sound = new Audio(nudge)

    if (!isNaN(this.timeRemaining)) {
      this.timer_duration = clonedeep(this.timeRemaining)
    }
  },
  watch: {
    time_remaining( newValue, oldValue ) {
      if (newValue === 0 && oldValue > 0) {
        this.time_out_sound.play()
        this.timer_status = 'stopped'
        this.$emit('timerStopped', 0);
      }
    },
    value(timeRemaining) {
      this.timer_duration = clonedeep(this.timeRemaining)
    },
  },

  beforeDestroy () {
    this.$emit('timerStopped', clonedeep(this.time_remaining));
  },

  computed: {
    ...mapGetters('session', [
      'session_user_timer',
      'session_timer_status',
      'session_system_time'
    ]),
    time_remaining() {
      if (this.timer_status === 'running') {
        return Math.max(0, this.timer_duration - (this.session_system_time - this.timer_started_at))
      } else {
        return this.timeRemaining
      }
    }
  },

  methods: {
    onMoveTaskToTop() {
    },

    onStartTimer() {
      this.timer_status = 'running'
      this.timer_started_at = this.session_system_time
      this.timer_duration = clonedeep(this.timeRemaining)
    },
    onStopTimer() {
      this.$emit('timerStopped', clonedeep(this.time_remaining));
      this.timer_status = 'stopped'
    },
  },
  filters: {
  },
  components: {
  }
};
</script>
